import LogModalView from './LogModalViewContainer';
export default LogModalView;
